import { Link } from "react-router-dom";
import { StoreButtons } from "./StoreModal";

function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="bg-[#1a1a1a] text-white px-4 md:px-10 py-10">
      <div className="container mx-auto flex flex-col gap-8 md:gap-10">
        {/* Top row */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="font-manrope-semibold text-xl text-white">
              Contentour Bonaire
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4 text-white"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"
              />
            </svg>
          </div>

          <button
            onClick={scrollToTop}
            className="w-10 h-10 rounded-full bg-white flex items-center justify-center hover:opacity-80 transition-opacity"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-4 h-4 text-black"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"
              />
            </svg>
          </button>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10" />

        {/* Main content */}
        <div className="flex flex-col md:flex-row md:flex-wrap md:justify-between gap-6 md:gap-10">
          {/* Nav links */}
          <div className="flex flex-col gap-2">
            {[
              { label: "Home", to: "/" },
              { label: "Services", to: "/services" },
              { label: "About us", to: "/about-us" },
              { label: "Support", to: "/support" },
              { label: "Privacy policy", to: "/privacy-policy" },
              { label: "Terms & conditions", to: "/terms-conditions" },
            ]
              .reduce((rows, link, i) => {
                const rowIndex = Math.floor(i / 3);
                if (!rows[rowIndex]) rows[rowIndex] = [];
                rows[rowIndex].push(link);
                return rows;
              }, [])
              .map((row, rowIndex) => (
                <div
                  key={rowIndex}
                  className="flex flex-row flex-wrap items-center gap-x-3 gap-y-1"
                >
                  {row.map(({ label, to }, i) => (
                    <div key={label} className="flex items-center gap-3">
                      {i > 0 && (
                        <span className="text-white/30 font-manrope-regular text-sm">
                          /
                        </span>
                      )}
                      <Link
                        to={to}
                        className="font-manrope-regular text-sm text-white/70 hover:text-white transition-colors"
                      >
                        {label}
                      </Link>
                    </div>
                  ))}
                </div>
              ))}
          </div>

          {/* Contact us */}
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <span className="font-manrope-regular text-sm text-white/50">
                Contact us
              </span>
              <a
                href="https://wa.me/5997018199"
                target="_blank"
                rel="noopener noreferrer"
                className="font-manrope-bold text-base text-white hover:text-primary transition-colors"
              >
                +599 701 8199
              </a>
            </div>
          </div>

          {/* Address */}
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <span className="font-manrope-regular text-sm text-white/50">
                Email
              </span>
              <span className="font-manrope-regular text-base text-white">
                info@contentourbonaire.com
              </span>
            </div>
          </div>

          {/* Download app */}
          <div className="flex flex-col gap-3 md:w-full">
            <span className="font-manrope-regular text-sm text-white/50">
              Download the app
            </span>
            <StoreButtons />
          </div>

          {/* Copyright */}
          <div className="flex items-end md:w-full md:justify-end">
            <span className="font-manrope-regular text-sm text-white/50">
              Copyright © 2026 Contentour Bonaire. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
